import useCampaignsData from "@/modules/common/hooks/campaigns-data.hook";
import { LeadPageContext } from "@/modules/lead-page/context/lead-page.context";
import { UUID } from "crypto";
import { useContext, useState, type SyntheticEvent } from "react";

const useEditCampaign = () => {
  const { lead } = useContext(LeadPageContext);
  const [editCampaignModalOpen, setEditCampaignModalOpen] = useState(false);
  const [campaign, setCampaign] = useState<{
    label: string;
    uid: UUID | string;
  } | null>(null);

  const handleChangeCampaign = (
    _event: SyntheticEvent<Element, Event>,
    value: { label: string; uid: UUID | string } | null
  ) => {
    setCampaign(value || null);
  };
  const { Campaigns } = useCampaignsData();

  return {
    campaign: {
      editCampaignModalOpen,
      setEditCampaignModalOpen,
      handleChangeCampaign,
      state: campaign,
      CampaignsData: Campaigns,
      setState: setCampaign,
      handleSearchChange: Campaigns.handleSearchChange,
      value: lead?.data?.lead?.campaign?.name,
    },
  };
};

export default useEditCampaign;
